import script from "./BalPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalPopover.vue?vue&type=script&setup=true&lang=ts"

import "./BalPopover.vue?vue&type=style&index=0&id=b8ca8116&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8ca8116"]])

export default __exports__